interface ModalOptions {
  title: string;
  subtitle?: string;
  body: string;
  onClose?: () => void;
}

export function createModal({ title, subtitle, body, onClose }: ModalOptions): { overlay: HTMLElement; close: () => void } {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal">
      <button class="modal__close">&times;</button>
      <h2 class="modal__title">${title}</h2>
      ${subtitle ? `<p class="modal__subtitle">${subtitle}</p>` : ''}
      <div class="modal__body">${body}</div>
    </div>
  `;
  document.body.appendChild(overlay);

  let closed = false;

  const close = () => {
    if (closed) return;
    closed = true;
    overlay.remove();
    document.removeEventListener('keydown', handleEscape);
    if (onClose) onClose();
  };

  const handleEscape = (e: KeyboardEvent) => {
    if (e.key === 'Escape') close();
  };

  overlay.querySelector('.modal__close')!.addEventListener('click', close);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', handleEscape);

  return { overlay, close };
}
